export default "__VITE_ASSET__DDoJY9Gv__"